import FieldConfig from "../../../proto/field-config";
import Task from "../../../../model2/task/task";
import FieldUsers from "../../../generic/users/users";
import FieldTaskUsers_TableCell from "./render/table/table-cell";

export default class FieldTaskUsers extends FieldUsers {

    constructor(config:FieldConfig) {
        super(config);

        this.icon       = 'i5-users'
        this.label      = 'All users'

        this.renderComponents.tableCell = FieldTaskUsers_TableCell
    }

    canEdit(model:Task):boolean {
        return false
    }
}
